import { showScriptsCommand } from '../../commands/scripts/showScripts';

export async function showScriptsTui() {
  await showScriptsCommand();
} 